export default __webpack_public_path__ + "static/media/NEUROLOGISTS.65de4d02.png";